import { CreateWatermarkSet, IWatermarkSet } from '@/types/watermarks.types';
import { Post } from '../helpers';
import { watermarkPath } from './path';

export default function CreateWatermark(watermark: CreateWatermarkSet) {
  return Post<IWatermarkSet>({
    path: watermarkPath(watermark.channel),
    body: watermark,
  });
}
